// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._1nvLq{width:86%;margin-bottom:10px}._2NUqM>*{margin:0 10px 0 0;padding:0}._3OVWz>a:after{content:\"\\f005\"}._3OVWz>a:after,.y_XYM>a:after{font-family:FontAwesome;color:#ffd800}.y_XYM>a:after{content:\"\\f005\\f005\"}._2mCwP>a:after{content:\"\\f005\\f005\\f005\"}._2mCwP>a:after,._2yK9E>a:after{font-family:FontAwesome;color:#ffd800}._2yK9E>a:after{content:\"\\f005\\f005\\f005\\f005\"}.xhGOt>a:after{font-family:FontAwesome;content:\"\\f005\\f005\\f005\\f005\\f005\";color:#ffd800}", ""]);
// Exports
exports.locals = {
	"root": "_1nvLq",
	"inline": "_2NUqM",
	"conf1": "_3OVWz",
	"conf2": "y_XYM",
	"conf3": "_2mCwP",
	"conf4": "_2yK9E",
	"conf5": "xhGOt"
};
module.exports = exports;
